import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import RSSB_LOGO from "../assets/RSSB_LOGO.jpeg";
import { useLocation } from "react-router-dom";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import { useEffect, useState } from "react";
import moment from "moment";

const DonationPreview = () => {
  const location = useLocation();
  const donationId = location?.state?.donationId;

  const [donation, setDonation] = useState(null);
  const [loading, setLoading] = useState(false);
  const getRefYear = (date) => {
    if (date) {
      return moment(date).year();
    }
    return moment().year();
  };

  const REF_BASE = "F.142/RSSB/JP";
  useEffect(() => {
    if (!donationId) return;

    const fetchDonation = async () => {
      try {
        setLoading(true);
        const res = await apiClient.get(
          `${SERVER_BASE}/getDonation/${donationId}`
        );
        setDonation(res.data);
        
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDonation();
  }, [donationId]);

  if (loading) {
    return <div className="text-center mt-4">Loading...</div>;
  }

  return (
    <div
      className="container my-2"
      style={{
        maxWidth: "1200px",   // ✅ maxWidth restored
        fontFamily: "Times New Roman",
        fontSize: "13px",
        lineHeight: "1.2",
      }}
    >
      {/* ================= HEADER ================= */}
      <div className="d-flex justify-content-between align-items-start mb-1">
        <img src={RSSB_LOGO} alt="RSSB" style={{ width: 40, height: 40 }} />

        <div className="text-center flex-grow-1">
          <div className="fw-bold">SATSANG CENTRES IN INDIA</div>
          <div className="fw-bold">
            OFFER OF ITEMS / MATERIAL IN DONATION
          </div>
        </div>

        <div className="fw-bold">SCI/2019/15</div>
      </div>

      {/* ================= META ================= */}
      <div className="row mb-1">
        <div className="col-9">
          <div>BEAS FILE NO.: 204008</div>
          <div>No.: {`${REF_BASE}/${getRefYear(donation?.header?.date)}/${donation?.header?.formNo}`}</div>
          <div>THE SEWADAR I/C SATSANG CENTRES IN INDIA</div>
          <div>RSSB, DERA BABA JAIMAL SINGH, DISTT. AMRITSAR</div>
        </div>
        <div className="col-3 text-end">
          DATE: {donation?.header?.date?moment(donation?.header?.date).format('DD/MM/YYYY'):''}
        </div>
      </div>

      {/* ================= PLACE DETAILS ================= */}
      <div className="d-flex justify-content-between mb-1">
        <div>
          NAME OF SATSANG PLACE: <b>{donation?.header?.satsangPlace.toUpperCase()}</b>
        </div>

        <div>
          ATTACHED TO: <b>{donation?.header?.attachedTo?.toUpperCase()}</b>
          {/* <br />
          (CENTRE) */}
        </div>

        <div>
          AREA: <b>{donation?.header?.area?.toUpperCase()}</b>
          <br />
          AVERAGE WEEKLY ATTENDANCE: ____________________
        </div>
      </div>

      <div className="mb-1">Dear Brother,</div>
      <div className="mb-2">
        An offer of the following items is being sent, for which approval may
        please be accorded.
      </div>

      {/* ================= MAIN ITEMS TABLE ================= */}
      <table
        className="table table-bordered text-center align-middle mb-2"
        style={{ border: "2px solid #000",fontSize:'12px'}}
      >
        <thead>
          <tr>
            <th rowSpan="2" className="fw-bold small p-1">SR. NO.</th>
            <th rowSpan="2" className="fw-bold small p-1">NAME OF ARTICLE</th>
            <th rowSpan="2" className="fw-bold small p-1">PRESENT OFFER</th>
            <th rowSpan="2" className="fw-bold small p-1">COST OF ITEM</th>
            <th rowSpan="2" className="fw-bold small p-1">
              JUSTIFICATION FOR ACCEPTANCE OR PURPOSE FOR WHICH REQUIRED
            </th>
            <th colSpan="2" className="fw-bold small p-1">
              EXISTING HOLDING
            </th>
            <th colSpan="2" className="fw-bold small p-1">
              DONOR DETAILS (ONLY INITIATED)
            </th>
            <th rowSpan="2" className="fw-bold small p-1">
              SIGNATURE OF DONOR
            </th>
          </tr>
          <tr>
            <th className="fw-bold small p-1">QUANTITY</th>
            <th className="fw-bold small p-1">DATE OF ACQUISITION</th>
            <th className="fw-bold small p-1">NAME</th>
            <th className="fw-bold small p-1">ADDRESS</th>
          </tr>
        </thead>
        <tbody>
  {(() => {
    const items = donation?.items || [];
    const donors = donation?.donors || [];

    const totalItems = items.length;
    const totalDonors = donors.length;

    if (!totalItems) return null;

    // calculate donor row spans
    const donorRowSpans =
      totalDonors > 0
        ? donors.map((_, index) => {
            const base = Math.floor(totalItems / totalDonors);
            const remainder = totalItems % totalDonors;
            return index < remainder ? base + 1 : base;
          })
        : [];

    let donorStartRow = 0;

    return items.map((item, rowIndex) => {
      let donorIndex = -1;

      for (let i = 0, acc = 0; i < donorRowSpans.length; i++) {
        if (rowIndex === acc) {
          donorIndex = i;
          donorStartRow = acc;
          break;
        }
        acc += donorRowSpans[i];
      }

      const donor = donorIndex !== -1 ? donors[donorIndex] : null;

      return (
        <tr key={rowIndex} style={{ height: 15 }}>
          <td>{item.srNo}</td>
          <td>{item.itemName}</td>
          <td>{item.presentOffer}</td>
          <td>{item.costOfItem}</td>
          <td>{item.justification}</td>
          <td>{item.existingQty}</td>
          <td>
            {item.acquisitionDate
              ? moment(item.acquisitionDate).format("DD/MM/YYYY")
              : ""}
          </td>

          {/* DONOR NAME (merged) */}
          {donor && (
            <td rowSpan={donorRowSpans[donorIndex]}>
              {donor.name}
            </td>
          )}

          {/* DONOR ADDRESS (merged) */}
          {donor && (
            <td rowSpan={donorRowSpans[donorIndex]}>
              {donor.address}
            </td>
          )}

{/* DONOR ADDRESS (merged) */}
          {donor && (
            <td rowSpan={donorRowSpans[donorIndex]}>  </td>
          )}
        </tr>
      );
    });
  })()}
</tbody>


      </table>
      <div className="text-end">INCHARGE/CT/SECRETARY</div>
      {/* ================= BOTTOM SECTION ================= */}
      <table
        className="table table-bordered mb-2"
        style={{ border: "2px solid #000" }}
      >
        <tbody>
          {/* ================= COMMON HEADING ROW ================= */}
          <tr>
            <td
              colSpan={2}
              style={{
                textAlign: "center",
                fontWeight: "bold",
                borderBottom: "1px solid white",
                padding: "4px 0",
              }}
            >
              RECOMMENDATIONS OF
            </td>
          </tr>

          {/* ================= ROW 1 : AREA + ZONAL + APPROVAL ================= */}
          <tr>
            {/* AREA SECRETARY */}
            <td style={{ width: "30%", verticalAlign: "top" }}>
              <div>No.: ____________________ &nbsp; Date: __________</div>

              <div>
                The sewa material being offered in donation is as per Beas
                Design & will be used as per Beas Drawings.
              </div>

              <br /><br /><br />

              <div className="text-end fw-bold">AREA SECRETARY</div>
            </td>

            {/* ZONAL SECRETARY */}
            <td style={{ width: "30%", verticalAlign: "top" }}>
              <div>No.: ____________________ &nbsp; Date: __________</div>

              <div>
                Specify whether Offer of Donation is against acceptance of cash
                Sewa –
                ☐ YES &nbsp;&nbsp; ☐ NO</div>

              <div>
                If yes, the information of Sewa in cash/bank should be reported
                to sewa@rssb.in
              </div>

              <br />

              <div className="text-end fw-bold">ZONAL SECRETARY</div>
            </td>

            {/* APPROVAL OF SECRETARY (FULL HEIGHT) */}
            <td
              rowSpan={3}
              style={{
                width: "40%",
                verticalAlign: "top",
                border: "1px solid #000",
                padding: "4px",
              }}
            >
              <div className="fw-bold text-center mb-1">
                APPROVAL OF SECRETARY, RSSB
              </div>

              <div className="d-flex justify-content-between mb-2">
                <div>No.: ____________________</div>
                <div>Date: __________</div>
              </div>

              <div style={{ minHeight: "80px" }}>
                <div># To be taken in Asset Register / Accounts.</div>
                <div># ______________________________</div>
              </div>

              <div
                className="fw-bold "
                style={{ marginTop: "60px" }}
              >
                <div className="text-end">SECRETARY, RSSB, BEAS</div>
                <div>RETURNED TO SIC, SATSANG CENTRES IN INDIA</div>
              </div>
            </td>
          </tr>

          {/* ================= ROW 2 : RECOMMENDED ================= */}
          <tr>
            <td colSpan={2} style={{ verticalAlign: "top" }}>
              <div>No.: ____________________ &nbsp; Date: __________</div>

              <div className="fw-bold mt-1">RECOMMENDED:</div>

              <ol className="mb-1">
                <li>
                  The Sewa material approved is to be used as per Beas approved
                  design/drawing.
                </li>
                <li>
                  No collection whatsoever is to be made at any Satsang Place.
                </li>
              </ol>

              <div className="text-end fw-bold">
                SIC SATSANG CENTRES IN INDIA
              </div>
            </td>
          </tr>
        </tbody>



      </table>

      {/* ================= FOOTER ================= */}
      <div style={{ fontSize: "13px" }}>
        Distribution – Incharge / CT / Secretary / Area Secretary / Zonal
        Secretary
        <br />
        <strong>CC – CAO – For necessary adjustment of Rs. __________ Please.</strong>
      </div>
    </div>
  );
};

export default DonationPreview;
